import React, { useEffect, useRef, useState } from 'react';
import { cn } from '@/lib/utils';
interface RevealProps {
    children: React.ReactNode;
    className?: string;
    delay?: number;
}
const Reveal: React.FC<RevealProps> = ({ children, className, delay = 0 }) => {
    const ref = useRef<HTMLDivElement | null>(null);
    const [visible, setVisible] = useState(false);
    useEffect(() => {
        const el = ref.current;
        if (!el)
            return;
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    setVisible(true);
                    observer.unobserve(entry.target);
                }
            });
        }, { threshold: 0.12 });
        observer.observe(el);
        return () => observer.disconnect();
    }, []);
    return (<div ref={ref} style={{ transitionDelay: `${delay}ms` }} className={cn('will-change-transform', visible ? 'animate-enter' : 'opacity-0 translate-y-3', className)}>
      {children}
    </div>);
};
export default Reveal;
